import { TOption } from "./common";
import { TQuoteLineItem } from "../common/types/quote";

export type TQuoteStatus = 1 | 3;
export const QuoteStatus: Record<'PENDING' | 'APPROVED', TQuoteStatus> = {
    PENDING: 1,
    APPROVED: 3,
};

export const QuoteStatusOption: TOption<TQuoteStatus>[] = [
    {
        value: QuoteStatus.PENDING,
        label: 'Pending',
    },
    {
        value: QuoteStatus.APPROVED,
        label: 'Approved',
    },
];

export const VEGETATION_DENSITY = {
    BARE: -2,
    LOW: -1,
    MEDIUM: 0,
    HIGH: 1,
    EXTREME: 2,
};

export const VEGETATION_DENSITY_FROM_INTERNAL = {
    [VEGETATION_DENSITY.BARE]: "BARE",
    [VEGETATION_DENSITY.LOW]: "LOW",
    [VEGETATION_DENSITY.MEDIUM]: "MEDIUM",
    [VEGETATION_DENSITY.HIGH]: "HIGH",
    [VEGETATION_DENSITY.EXTREME]: "EXTREME",
};

export const VEGETATION_DENSITY_TO_INTERNAL = {
    "BARE": -2,
    "LOW": -1,
    "MEDIUM": 0,
    "HIGH": 1,
    "EXTREME": 2,
};

export const VEGETATION_DENSITY_MAP = {
    [VEGETATION_DENSITY.BARE]: {
        title: "Bare Density",
        description: "Minimal vegetation and sparse natural cover, where the density of surface features like trees, shrubs, or built structures is extremely low. The terrain often appears exposed, with visible soil, rock, or sand dominating the surface.",
    },
    [VEGETATION_DENSITY.LOW]: {
        title: "Low Density",
        description: "A low-density terrain features widely spaced natural or man-made elements, such as scattered vegetation, or isolated topographic features. Unlike bare terrain, it retains some coverage—like patches of trees or shrubs while still allowing much of the ground surface to remain visible. This type of terrain often appears semi-open, striking a balance between openness and coverage, and is common in transitional zones between urban and rural areas, or in lightly forested regions.",
    },
    [VEGETATION_DENSITY.MEDIUM]: {
        title: "Medium Density",
        description: "A medium amount of vegetation density typically features a balanced mix of plant life that is neither sparse nor overly lush. It includes a moderate spread of trees, shrubs, and ground cover, allowing for some open spaces between plants.",
    },
    [VEGETATION_DENSITY.HIGH]: {
        title: "High Density",
        description: "A high-density terrain is characterized by a concentration of natural elements such as closely packed trees, thick underbrush, or dense vegetation. The landscape offers limited visibility and restricted movement due to the abundance of overlapping organic features. This type of terrain is common in mature forests, jungles, or mountainous areas with rich, uninterrupted plant growth, where the ground surface is largely obscured by natural cover.",
    },
    [VEGETATION_DENSITY.EXTREME]: {
        title: "Extreme Density",
        description: "An extreme-density terrain is dominated by an overwhelming abundance of natural features, such as tightly interwoven trees, dense thickets, and layered vegetation with little to no open space. The canopy may be nearly continuous, and ground visibility is minimal due to the thick undergrowth and overlapping plant life. Movement through this type of terrain is highly restricted, often requiring deliberate clearing or navigation through narrow natural paths. Such environments are typical of deep rainforests or heavily overgrown wilderness areas.",
    },
};

export const DEFAULT_LINE_ITEMS = [
    {
        description: "Terrain category",
        lineItemCategoryId: 1,
        quoteId: 0,
        order: 0,
    },
] as TQuoteLineItem[];
